import { useEffect } from "react";
import { useSelector } from "react-redux";

// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import mapboxglx from "mapbox-gl";
import { RootState } from "store/rootReducer";

import { emptyFeatureCollection } from "../utils/emptyFeatureCollection";

export function useSyncWellHighlighting(mapbox: mapboxglx.Map, layer: string) {
  const syncWells = useSelector((state: RootState) => state.app.syncWells);

  useEffect(() => {
    if (!mapbox || !syncWells) {
      return;
    }
    if (syncWells?.highlightSyncedWell === false && mapbox) {
      const source = mapbox.getSource(layer) as mapboxgl.GeoJSONSource;
      if (source) {
        source.setData({ ...emptyFeatureCollection });
      }
    }
  }, [mapbox, syncWells?.highlightSyncedWell]);
}
